import { Component, Input } from '@angular/core';
import { NotificationHistory } from '@cl/shared/models/notification-history.model';

@Component({
    selector: 'cl-notification-history-entry-details',
    standalone: false,
    templateUrl: './notification-history-entry-details.component.html',
    styleUrl: './notification-history-entry-details.component.less',
})
export class NotificationHistoryEntryDetailsComponent {
    @Input() notificationHistory: NotificationHistory;
}
